/**
 * Asistente IA para Blog - SinAdicciones.org
 * Genera contenido SEO optimizado con conocimiento del sitio
 */

// Mapa del sitio para enlaces internos
export const SITEMAP_INTERNO = {
  // Directorios principales
  centros: { url: "/centros-de-rehabilitacion-drogas-chile", texto: "directorio de centros de rehabilitación", keywords: ["centros", "rehabilitación", "clínicas"] },
  profesionales: { url: "/profesionales", texto: "directorio de profesionales", keywords: ["profesionales", "psicólogos", "terapeutas", "psiquiatras"] },
  talleres: { url: "/talleres", texto: "directorio de talleres", keywords: ["talleres", "grupos", "actividades"] },
  
  // Herramientas
  calculadora: { url: "/herramientas/calculadora-costos", texto: "calculadora de costos de rehabilitación", keywords: ["calculadora", "costos", "precios", "cuánto cuesta"] },
  testAlcoholismo: { url: "/herramientas/test-alcoholismo", texto: "test de alcoholismo", keywords: ["test alcoholismo", "AUDIT", "evaluar alcoholismo"] },
  testDrogas: { url: "/herramientas/test-dependencia", texto: "test de dependencia a drogas", keywords: ["test drogas", "dependencia", "evaluar adicción"] },
  testLudopatia: { url: "/herramientas/test-ludopatia", texto: "test de ludopatía", keywords: ["test ludopatía", "adicción juego", "evaluar ludopatía"] },
  
  // Páginas informativas
  planes: { url: "/planes", texto: "planes de suscripción", keywords: ["planes", "suscripción", "precios centros"] },
  contacto: { url: "/contacto", texto: "formulario de contacto", keywords: ["contacto", "contactar", "ayuda"] },
  quienesSomos: { url: "/quienes-somos", texto: "quiénes somos", keywords: ["sobre nosotros", "equipo", "misión"] },
  
  // Landings por tipo de tratamiento
  residencial: { url: "/centro/residencial/santiago", texto: "centros residenciales", keywords: ["residencial", "internación", "internado"] },
  ambulatorio: { url: "/centro/ambulatorio/santiago", texto: "tratamiento ambulatorio", keywords: ["ambulatorio", "sin internación", "día"] },
  
  // Landings por adicción
  alcoholismo: { url: "/adicciones/alcoholismo", texto: "información sobre alcoholismo", keywords: ["alcoholismo", "alcohol", "bebida"] },
  drogas: { url: "/adicciones/drogas", texto: "información sobre drogas", keywords: ["drogas", "sustancias", "estupefacientes"] },
  cocaina: { url: "/adicciones/cocaina", texto: "información sobre cocaína", keywords: ["cocaína", "coca", "crack"] },
  marihuana: { url: "/adicciones/marihuana", texto: "información sobre marihuana", keywords: ["marihuana", "cannabis", "THC"] },
  pastaBase: { url: "/adicciones/pasta-base", texto: "información sobre pasta base", keywords: ["pasta base", "paco", "base"] },
  
  // Blog
  blog: { url: "/blog", texto: "blog de adicciones", keywords: ["artículos", "blog", "información"] }
};

// Templates de contenido
export const TEMPLATES = {
  tablaComparativa: `
<table class="w-full border-collapse my-6">
<thead>
<tr class="bg-slate-800">
<th class="border border-slate-600 p-3 text-left">[Columna 1]</th>
<th class="border border-slate-600 p-3 text-left">[Columna 2]</th>
<th class="border border-slate-600 p-3 text-left">[Columna 3]</th>
</tr>
</thead>
<tbody>
<tr>
<td class="border border-slate-700 p-3">[Dato 1]</td>
<td class="border border-slate-700 p-3">[Dato 2]</td>
<td class="border border-slate-700 p-3">[Dato 3]</td>
</tr>
</tbody>
</table>`,

  faq: `
<h2>Preguntas Frecuentes</h2>

<h3>¿[Pregunta 1]?</h3>
<p>[Respuesta detallada a la pregunta 1]</p>

<h3>¿[Pregunta 2]?</h3>
<p>[Respuesta detallada a la pregunta 2]</p>

<h3>¿[Pregunta 3]?</h3>
<p>[Respuesta detallada a la pregunta 3]</p>`,

  cta: `
<p class="my-6">
<a href="[URL]" class="inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors">
[Texto del botón]
</a>
</p>`,

  listaConIconos: `
<ul>
<li><strong>[Punto 1]:</strong> [Descripción del punto 1]</li>
<li><strong>[Punto 2]:</strong> [Descripción del punto 2]</li>
<li><strong>[Punto 3]:</strong> [Descripción del punto 3]</li>
</ul>`
};

// Prompts para la IA
export const AI_PROMPTS = {
  // Sistema base que conoce el sitio
  systemBase: `Eres un experto en contenido SEO para SinAdicciones.org, un sitio web chileno sobre rehabilitación de adicciones.

CONOCIMIENTO DEL SITIO:
- Directorio de centros: /centros-de-rehabilitacion-drogas-chile
- Directorio de profesionales: /profesionales
- Calculadora de costos: /herramientas/calculadora-costos
- Test de alcoholismo: /herramientas/test-alcoholismo
- Test de dependencia: /herramientas/test-dependencia
- Contacto: /contacto
- Planes: /planes

REGLAS DE CONTENIDO:
1. Escribe en español de Chile (usa "tú" informal)
2. Sé empático y profesional (tema sensible)
3. Incluye datos específicos de Chile cuando sea posible
4. Usa formato HTML válido
5. Agrega enlaces internos relevantes usando <a href="/ruta">texto</a>
6. Las tablas deben usar clases Tailwind: border-collapse, bg-slate-800, border-slate-600
7. Los CTAs deben usar: bg-emerald-500 hover:bg-emerald-600 text-white

ESTRUCTURA SEO:
- Usa H2 para secciones principales
- Usa H3 para subsecciones
- Incluye listas con <ul> y <li>
- Agrega <strong> para keywords importantes`,

  // Prompt para crear artículo completo
  crearArticulo: (tema) => `
Crea un artículo completo y SEO optimizado sobre: "${tema}"

El artículo debe incluir:
1. Introducción con párrafo lead (usa class="lead")
2. Al menos 4 secciones H2
3. Una tabla comparativa si es relevante
4. Lista de puntos clave
5. Sección de preguntas frecuentes (3-5 preguntas)
6. Conclusión con CTA
7. Enlaces internos a páginas relevantes del sitio

Extensión: 1500-2000 palabras
Formato: HTML válido`,

  // Prompt para crear tabla
  crearTabla: (tema) => `
Crea una tabla HTML comparativa sobre: "${tema}"

La tabla debe:
- Tener encabezado con fondo oscuro (bg-slate-800)
- Bordes sutiles (border-slate-600, border-slate-700)
- Datos realistas y útiles para Chile
- Al menos 4-5 filas de datos

Usa este formato exacto:
<table class="w-full border-collapse my-6">
<thead>
<tr class="bg-slate-800">
<th class="border border-slate-600 p-3 text-left">Encabezado</th>
</tr>
</thead>
<tbody>
<tr>
<td class="border border-slate-700 p-3">Dato</td>
</tr>
</tbody>
</table>`,

  // Prompt para crear FAQ
  crearFAQ: (tema) => `
Crea una sección de Preguntas Frecuentes (FAQ) sobre: "${tema}"

Incluye 5-7 preguntas comunes que las personas buscan en Google.
Cada respuesta debe ser completa (2-3 oraciones mínimo).
Si es relevante, incluye enlaces a herramientas del sitio.

Formato:
<h2>Preguntas Frecuentes sobre [tema]</h2>
<h3>¿Pregunta?</h3>
<p>Respuesta completa.</p>`,

  // Prompt para sugerir enlaces internos
  sugerirEnlaces: (contenido) => `
Analiza este contenido y sugiere dónde agregar enlaces internos:

${contenido}

Enlaces disponibles del sitio:
- /centros-de-rehabilitacion-drogas-chile (directorio de centros)
- /profesionales (directorio de profesionales)
- /herramientas/calculadora-costos (calculadora)
- /herramientas/test-alcoholismo (test AUDIT)
- /herramientas/test-dependencia (test de drogas)
- /contacto (formulario de contacto)
- /planes (información de planes)

Devuelve el contenido con los enlaces agregados usando <a href="/ruta">texto</a>`,

  // Prompt para crear CTA
  crearCTA: (accion, destino) => `
Crea un bloque de llamada a acción (CTA) para: "${accion}"

Destino: ${destino}

Usa este formato exacto:
<p class="my-6">
<a href="[URL]" class="inline-block bg-emerald-500 hover:bg-emerald-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors">
[Texto persuasivo]
</a>
</p>

También agrega un párrafo introductorio antes del botón que motive al usuario.`,

  // Prompt para mejorar SEO
  mejorarSEO: (contenido) => `
Mejora el SEO de este contenido:

${contenido}

Mejoras a realizar:
1. Agregar más keywords relevantes en negrita
2. Mejorar los títulos H2/H3 para que sean más descriptivos
3. Agregar enlaces internos donde falten
4. Expandir secciones cortas
5. Agregar una lista de puntos clave si no existe
6. Mejorar la conclusión con CTA

Devuelve el contenido mejorado en HTML.`
};

// Tipos de asistencia disponibles
export const AI_ASSISTANCE_TYPES = [
  {
    id: 'articulo',
    label: 'Crear artículo completo',
    icon: '📝',
    description: 'Genera un artículo SEO con tablas, FAQ y CTAs',
    placeholder: 'Ej: Tratamiento de alcoholismo en Chile, Cómo elegir un centro de rehabilitación...'
  },
  {
    id: 'tabla',
    label: 'Crear tabla comparativa',
    icon: '📊',
    description: 'Genera una tabla con datos comparativos',
    placeholder: 'Ej: Comparar precios de tratamientos, Tipos de terapia...'
  },
  {
    id: 'faq',
    label: 'Crear sección FAQ',
    icon: '❓',
    description: 'Genera preguntas frecuentes sobre el tema',
    placeholder: 'Ej: Preguntas sobre rehabilitación, Dudas sobre costos...'
  },
  {
    id: 'cta',
    label: 'Crear llamada a acción',
    icon: '🎯',
    description: 'Genera un bloque CTA con botón',
    placeholder: 'Ej: Invitar a usar la calculadora, Contactar para más info...'
  },
  {
    id: 'enlaces',
    label: 'Agregar enlaces internos',
    icon: '🔗',
    description: 'Analiza y agrega enlaces a páginas del sitio',
    placeholder: 'El contenido actual será analizado automáticamente'
  },
  {
    id: 'mejorar',
    label: 'Mejorar SEO del contenido',
    icon: '✨',
    description: 'Optimiza el contenido existente para Google',
    placeholder: 'El contenido actual será mejorado automáticamente'
  }
];

// Función para obtener el prompt según el tipo
export function getAIPrompt(type, input, currentContent = '') {
  switch (type) {
    case 'articulo':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.crearArticulo(input)
      };
    case 'tabla':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.crearTabla(input)
      };
    case 'faq':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.crearFAQ(input)
      };
    case 'cta':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.crearCTA(input, '/contacto')
      };
    case 'enlaces':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.sugerirEnlaces(currentContent || input)
      };
    case 'mejorar':
      return {
        system: AI_PROMPTS.systemBase,
        user: AI_PROMPTS.mejorarSEO(currentContent || input)
      };
    default:
      return {
        system: AI_PROMPTS.systemBase,
        user: input
      };
  }
}

// Función para encontrar enlaces internos relevantes
export function findRelevantInternalLinks(text) {
  const relevantLinks = [];
  const textLower = text.toLowerCase();
  
  Object.entries(SITEMAP_INTERNO).forEach(([key, data]) => {
    data.keywords.forEach(keyword => {
      if (textLower.includes(keyword.toLowerCase())) {
        if (!relevantLinks.find(l => l.url === data.url)) {
          relevantLinks.push({
            key,
            url: data.url,
            texto: data.texto,
            matchedKeyword: keyword
          });
        }
      }
    });
  });
  
  return relevantLinks;
}
